import { render, staticRenderFns } from "./pnl-indicator.component.vue?vue&type=template&id=11e6e7d3&scoped=true"
import script from "./pnl-indicator.component.vue?vue&type=script&lang=js"
export * from "./pnl-indicator.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e6e7d3",
  null
  
)

export default component.exports